var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('guide-visual', _vm._b({}, 'guide-visual', _vm.visual, false)), _c('section', [_c('v-card', {
    staticClass: "py-40",
    attrs: {
      "img": "/images/guide/honors/bg.jpg",
      "tile": "",
      "flat": ""
    }
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "src": "/images/guide/honors/honors-card.svg"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "font-size-20 font-size-lg-36 font-aggro font-weight-medium primary--text"
  }, [_vm._v(" With You, With CAN "), _c('br'), _vm._v(" Honors Club ")]), _c('p', {
    staticClass: "page-text page-text--lg primary--text mt-4"
  }, [_vm._v("위드캔 아너스클럽")])])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm font-weight-medium"
  }, [_vm._v(" 나눔을 실천하며 "), _c('br'), _vm._v(" 위드캔복지재단과 함께 하는 나눔리더 ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('contact-dialog', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "primary--text",
          attrs: {
            "large": "",
            "rounded": "pill",
            "width": "220"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "font-size-lg-20"
        }, [_vm._v("기부 상담하기")]), _c('v-icon', {
          staticClass: "ml-10",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chevron-right")])], 1)];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('scrolldown-tail'), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("위드캔 아너스클럽 회원 기준")])]), _c('v-card', {
    staticClass: "border-radius-16 overflow-hidden pa-12 pa-lg-0",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "/images/guide/honors/member.jpg",
      "alt": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-row', {
    staticClass: "row--xxs"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "standard-stage",
    attrs: {
      "color": "#f5f5f5"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm primary--text"
  }, [_vm._v("정회원")])])], 1), _c('v-col', [_c('p', {
    staticClass: "page-text page-text--lg grey-1--text"
  }, [_vm._v("현금 2천만원 이상을 기부한 개인 후원자")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "standard-stage",
    attrs: {
      "color": "primary lighten-4"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm"
  }, [_vm._v("약정회원")])])], 1), _c('v-col', [_c('p', {
    staticClass: "page-text page-text--lg grey-1--text"
  }, [_vm._v(" 현금 2천만원을 3년 내 "), _c('br'), _vm._v(" 기부하기로 약정한 개인 후원자 ")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    staticClass: "standard-stage",
    attrs: {
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm white--text"
  }, [_vm._v("리더회원")])])], 1), _c('v-col', [_c('p', {
    staticClass: "page-text page-text--lg grey-1--text"
  }, [_vm._v(" 현금 2천만원을 후원하며, "), _c('br'), _vm._v(" 가족 또는 제3자를 회원으로 추대한 개인 후원자 ")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("위드캔 아너스클럽 가입 절차")])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/guide/honors/process-list.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-row', {
    staticClass: "process-list row--lg"
  }, _vm._l(_vm.process, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "lg": "3"
      }
    }, [_c('v-card', {
      staticClass: "process-card",
      attrs: {
        "color": "#FAFAFA",
        "flat": ""
      }
    }, [_c('v-row', {
      staticClass: "text-center"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "primary--text font-weight-bold font-size-28"
    }, [_vm._v("0" + _vm._s(index + 1))]), _c('div', {
      staticClass: "client-title--xs font-weight-bold mt-16",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _c('v-img', {
      staticClass: "my-28 mx-auto",
      attrs: {
        "src": `/images/guide/honors/process-${index + 1}.svg`,
        "max-width": "60"
      }
    })], 1)], 1)], 1)], 1);
  }), 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title word-keep-all"
  }, [_vm._v(" 위드캔 아너스클럽 후원자 "), _c('br', {
    staticClass: "d-md-none"
  }), _vm._v(" 예우 ")])]), _c('v-row', _vm._l(_vm.respect, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "3"
      }
    }, [_c('v-card', {
      staticClass: "mx-auto text-center h-100 border-radius-16",
      attrs: {
        "color": "#ddd",
        "max-width": "282",
        "outlined": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": item.image,
        "alt": ""
      }
    }), _c('v-card-title', {
      staticClass: "justify-center pt-lg-24"
    }, [_c('div', {
      staticClass: "tit tit--sm primary--text",
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })]), _c('v-card-text', {
      staticClass: "pb-lg-24"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.texts)
      }
    })])], 1)], 1);
  }), 1), _c('div', {
    staticClass: "mt-24"
  }, [_c('v-divider'), _c('p', {
    staticClass: "page-text text-center py-16"
  }, [_vm._v("위드캔복지재단은 지정기부금 단체로 기부금 1천만원 이하 15%, 1천만원 초과 30%까지연말정산 시 세액공제 혜택을 받으실 수 있습니다.")]), _c('v-divider')], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }